var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8.75,
    fill: "#273848"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2928)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 18.668C36.6388 18.668 38.3197 18.7101 39.9489 18.7791L41.8732 18.8711L43.7151 18.9804L45.4401 19.0973L47.0156 19.22C48.7254 19.3508 50.3342 20.0805 51.5591 21.2805C52.784 22.4805 53.5465 24.074 53.7125 25.7807L53.7891 26.5953L53.9329 28.3395C54.067 30.1469 54.1667 32.1172 54.1667 34.0013C54.1667 35.8854 54.067 37.8557 53.9329 39.6631L53.7891 41.4073C53.7642 41.6871 53.7393 41.9574 53.7125 42.2219C53.5465 43.9289 52.7837 45.5227 51.5584 46.7227C50.3331 47.9228 48.7238 48.6522 47.0137 48.7826L45.442 48.9034L43.717 49.0222L41.8732 49.1315L39.9489 49.2235C38.3002 49.2951 36.6502 49.3322 35 49.3346C33.3498 49.3322 31.6999 49.2951 30.0512 49.2235L28.1269 49.1315L26.285 49.0222L24.56 48.9034L22.9845 48.7826C21.2747 48.6518 19.6658 47.9222 18.4409 46.7221C17.216 45.5221 16.4536 43.9286 16.2876 42.2219L16.211 41.4073L16.0672 39.6631C15.9207 37.7793 15.8427 35.8908 15.8334 34.0013C15.8334 32.1172 15.933 30.1469 16.0672 28.3395L16.211 26.5953C16.2359 26.3155 16.2608 26.0452 16.2876 25.7807C16.4535 24.0743 17.2157 22.481 18.4402 21.281C19.6647 20.0811 21.2731 19.3513 22.9825 19.22L24.5561 19.0973L26.2811 18.9804L28.125 18.8711L30.0493 18.7791C31.6986 18.7075 33.3492 18.6705 35 18.668ZM31.1667 29.3534V38.6492C31.1667 39.5347 32.125 40.0867 32.8917 39.6459L40.9417 34.998C41.1169 34.8971 41.2624 34.7519 41.3635 34.5769C41.4647 34.402 41.518 34.2034 41.518 34.0013C41.518 33.7992 41.4647 33.6006 41.3635 33.4257C41.2624 33.2507 41.1169 33.1055 40.9417 33.0046L32.8917 28.3586C32.7168 28.2577 32.5185 28.2045 32.3165 28.2046C32.1146 28.2046 31.9162 28.2578 31.7414 28.3588C31.5665 28.4598 31.4214 28.6051 31.3205 28.78C31.2196 28.955 31.1666 29.1534 31.1667 29.3553V29.3534Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeA);
export default __webpack_public_path__ + "static/media/youtube_a.1adecedc223e832d505379d74f35a9d4.svg";
export { ForwardRef as ReactComponent };